"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateZipCode = exports.validatePaymentInfo = exports.validateInputFieldValue = exports.validateCustomFields = exports.validateCardNumber = exports.validateCardExpiry = exports.validateCardCVV = exports.validateBillingNameField = exports.isCustomFieldValid = exports._validateZipCode = exports._validateInputFieldValue = exports._validateCardNumber = exports._validateCardExpiry = exports._validateCardCVV = void 0;
var _validations = require("../validations");
var _constants = require("../../constants/constants");
var _nativePaymentPropsGenerator = require("./nativePaymentPropsGenerator");
var _commonUtils = require("../commonUtils");
var isCustomFieldValid = function isCustomFieldValid(referenceContainer) {
  validateCustomFields(referenceContainer);
  return !(0, _commonUtils.classExists)(['payment-widget__checkout__fields__input__error']);
};
exports.isCustomFieldValid = isCustomFieldValid;
var validateCustomFields = function validateCustomFields(referenceContainer) {
  (0, _commonUtils.focusOnCustomFields)([referenceContainer['emailInputField'], referenceContainer['phoneInputField'], referenceContainer['nameInputField']]);
};
exports.validateCustomFields = validateCustomFields;
var validatePaymentInfo = function validatePaymentInfo(paymentInfo, formatMessage, cardTypes) {
  var addressLine = {
      value: paymentInfo.addressLine.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getAddressLineErrorMessages)(formatMessage), paymentInfo.addressLine.value)
    },
    cardCVV = {
      value: paymentInfo.cardCVV.value,
      error: validateCardCVV((0, _nativePaymentPropsGenerator.getCardCVVErrorMessages)(formatMessage), paymentInfo.cardCVV.value)
    },
    cardExpiry = {
      value: paymentInfo.cardExpiry.value,
      error: validateCardExpiry((0, _nativePaymentPropsGenerator.getCardExpiryErrorMessages)(formatMessage), paymentInfo.cardExpiry.value)
    },
    cardNumber = {
      value: paymentInfo.cardNumber.value,
      error: validateCardNumber((0, _nativePaymentPropsGenerator.getCardNumberErrorMessages)(formatMessage), paymentInfo.cardNumber.value, {
        cardTypes: cardTypes
      })
    },
    firstName = {
      value: paymentInfo.firstName.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo.firstName.value)
    },
    lastName = {
      value: paymentInfo.lastName.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo.lastName.value)
    },
    fullName = {
      value: paymentInfo.fullName.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getNameErrorMessages)(formatMessage), paymentInfo.fullName.value)
    },
    city = {
      value: paymentInfo.city.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getCityErrorMessages)(formatMessage), paymentInfo.city.value)
    },
    country = {
      value: paymentInfo.country.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getCountryErrorMessages)(formatMessage), paymentInfo.country.value)
    },
    state = {
      value: paymentInfo.state.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getStateErrorMessages)(formatMessage), paymentInfo.state.value)
    },
    zipCode = {
      value: paymentInfo.zipCode.value,
      error: (0, _validations.validateIsEmpty)((0, _nativePaymentPropsGenerator.getZipCodeErrorMessages)(formatMessage), paymentInfo.zipCode.value)
    };
  var isValid = addressLine.error === '' && cardCVV.error === '' && cardExpiry.error === '' && cardNumber.error === '' && city.error === '' && country.error === '' && state.error === '' && zipCode.error === '' && (firstName.error === '' && lastName.error === '' || fullName.error === '');
  return {
    addressLine: addressLine,
    firstName: firstName,
    lastName: lastName,
    fullName: fullName,
    cardCVV: cardCVV,
    cardExpiry: cardExpiry,
    cardNumber: cardNumber,
    city: city,
    country: country,
    state: state,
    zipCode: zipCode,
    isValid: isValid
  };
};
exports.validatePaymentInfo = validatePaymentInfo;
var _validateCardNumber = function _validateCardNumber(props, value, errorMessages) {
  var cardTypes = props.cardTypes || [];
  var pattern = props.pattern || _constants.CARD_NUMBER_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return errorMessages.isInvalidMessage;
  }
  if (!cardTypes.includes((0, _commonUtils.getFullCardNumberType)(value))) {
    return errorMessages.cardTypeNotSupported;
  }
  if (!(0, _commonUtils.luhnValidator)(value)) {
    return errorMessages.isInvalidMessage;
  }
  return '';
};
exports._validateCardNumber = _validateCardNumber;
var _validateCardExpiry = function _validateCardExpiry(props, value) {
  var pattern = props.pattern || _constants.CARD_EXPIRY_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return props.isInvalidMessage;
  }
  var currentDate = new Date();
  var expiryDateValues = value.split('/');
  var expiryDate = new Date((0, _commonUtils.getFullYear)(expiryDateValues[1]), expiryDateValues[0], 0);
  if (expiryDate < currentDate) {
    return props.cardExpired;
  }
  return '';
};
exports._validateCardExpiry = _validateCardExpiry;
var _validateCardCVV = function _validateCardCVV(props, value) {
  var pattern = props.pattern || _constants.CARD_CVV_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return props.isInvalidMessage;
  }
  return '';
};
exports._validateCardCVV = _validateCardCVV;
var validateCardNumber = function validateCardNumber(errorMessages, value, props) {
  return (0, _validations.fieldIsEmpty)(errorMessages.isEmptyMessage)(value) || _validateCardNumber(props, value, errorMessages);
};
exports.validateCardNumber = validateCardNumber;
var validateCardExpiry = function validateCardExpiry(props, value) {
  return (0, _validations.fieldIsEmpty)(props.isEmptyMessage)(value) || _validateCardExpiry(props, value);
};
exports.validateCardExpiry = validateCardExpiry;
var validateCardCVV = function validateCardCVV(props, value) {
  return (0, _validations.fieldIsEmpty)(props.isEmptyMessage)(value) || _validateCardCVV(props, value);
};
exports.validateCardCVV = validateCardCVV;
var _validateZipCode = function _validateZipCode(errorMessages, value, props) {
  var country = props.country;
  var pattern = errorMessages.pattern || _constants.ZIP_CODE_VALIDATION_REGEX;
  if (country === 'US' && !pattern.test(value)) {
    return errorMessages.isInvalidMessage;
  }
  return '';
};
exports._validateZipCode = _validateZipCode;
var validateZipCode = function validateZipCode(errorMessages, value, props) {
  return (0, _validations.fieldIsEmpty)(errorMessages.isEmptyMessage)(value) || _validateZipCode(errorMessages, value, props);
};
exports.validateZipCode = validateZipCode;
var validateBillingNameField = function validateBillingNameField(paymentMethodDetails) {
  if (paymentMethodDetails.widgetNameOrder == 'FN') {
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__full-name_input');
  } else {
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__first-name_input');
    (0, _commonUtils.focusOnDOMElementWithId)('payment-widget__checkout__last-name_input');
  }
};
exports.validateBillingNameField = validateBillingNameField;
var _validateInputFieldValue = function _validateInputFieldValue(errorMessages, value, props) {
  var pattern = _constants.BILLING_ADDRESS_VALIDATION_REGEX;
  if (!pattern.test(value)) {
    return errorMessages.isInvalidValue;
  }
  if (_constants.EMOJI_REGEX.test(value)) {
    return errorMessages.isInvalidValue;
  }
  return '';
};
exports._validateInputFieldValue = _validateInputFieldValue;
var validateInputFieldValue = function validateInputFieldValue(errorMessages, value, props) {
  return (0, _validations.validateIsEmpty)(errorMessages.isEmptyMessage, value) || _validateInputFieldValue(errorMessages, value, props);
};
exports.validateInputFieldValue = validateInputFieldValue;